var render, staticRenderFns
import script from "./TestResultMixin.vue?vue&type=script&lang=ts"
export * from "./TestResultMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3510268",
  null
  
)

export default component.exports